import { AbsenceRequest } from "@/entities/absenceRequest/absenceRequest"
import { format, isSameDay } from "date-fns"
import { fr } from "date-fns/locale"
import clsx from "clsx"

export function getStatusBadge(status: AbsenceRequest["status"], isFull?: boolean) {
   let label = "???"
   let badgeClass = "badge-error"

   switch (status) {
      case "pending":
         label = "En attente"
         badgeClass = "badge-info"
         break
      case "validated":
         label = "Validée"
         badgeClass = "badge-success"
         break
      case "validated_but_to_justify":
         label = "À justifier"
         badgeClass = "badge-success"
         break
      case "rejected":
         label = "Refusée"
         badgeClass = "badge-error"
         break
      case "canceled":
         label = "Annulée"
         badgeClass = "badge-error"
         break
   }

   return <span className={clsx("badge", badgeClass, isFull && "badge-lg")}>{label}</span>
}

export function formatDateRange(from: Date, to: Date, type: string) {
   const timeFormat = "HH:mm"

   if (type === "late") {
      return `${format(from, "d MMMM   ", { locale: fr })} ${format(to, timeFormat)}`
   }

   if (isSameDay(from, to)) {
      return `${format(from, "d MMMM   ", { locale: fr })} ${format(from, timeFormat)} → ${format(
         to,
         timeFormat,
      )}`
   }
   return `${format(from, "d MMMM    HH:mm", { locale: fr })} → ${format(to, "d MMMM    HH:mm", {
      locale: fr,
   })}`
}

export function formatPeriodSmall(from: Date, to: Date) {
   if (isSameDay(from, to)) {
      return format(from, "d MMMM", { locale: fr })
   }
   return `${format(from, "d MMMM", { locale: fr })} → ${format(to, "d MMMM", {
      locale: fr,
   })}`
}
